export default "<div>\n\t<span>{{value}} / {{maxlength}}</span>\n</div>"